import { queryClient } from "utils/react-query";
const collection = "projects";

export const projectKeys = {
  all: [collection],
  coordinators: (projectId) => [collection, "coordinators", projectId],
};

export function invalidateAllProjectQueries() {
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) => queryKey[0] === collection,
  });
}
